var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacebook(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 50,
    viewBox: "0 0 49 50",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_23894_45360)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.356 49.3039C37.7912 49.3039 48.6825 38.4125 48.6825 24.9774C48.6825 11.5422 37.7912 0.650879 24.356 0.650879C10.9209 0.650879 0.029541 11.5422 0.029541 24.9774C0.029541 38.4125 10.9209 49.3039 24.356 49.3039Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.3567 47.201C36.6305 47.201 46.5804 37.2511 46.5804 24.9773C46.5804 12.7035 36.6305 2.75366 24.3567 2.75366C12.0829 2.75366 2.13306 12.7035 2.13306 24.9773C2.13306 37.2511 12.0829 47.201 24.3567 47.201Z",
    fill: "url(#paint0_linear_23894_45360)"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.3,
    d: "M24.3564 5.6049C18.9449 5.60449 13.7442 7.70315 9.84853 11.4593C5.9529 15.2154 3.66608 20.3362 3.46924 25.7441C3.46924 25.4928 3.46924 25.2353 3.46924 24.9839C3.46924 19.4394 5.67178 14.122 9.59234 10.2015C13.5129 6.2809 18.8303 4.07837 24.3748 4.07837C29.9193 4.07837 35.2367 6.2809 39.1573 10.2015C43.0778 14.122 45.2804 19.4394 45.2804 24.9839C45.2804 25.2353 45.2804 25.4928 45.2804 25.7441C45.0818 20.3304 42.7894 15.205 38.8862 11.4482C34.983 7.69142 29.7738 5.59649 24.3564 5.6049Z",
    fill: "#021123"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.4952 15.6312H28.8665C26.7913 15.6312 26.4108 16.6081 26.4108 18.0492V21.2363H31.3223V26.2041H26.4177V38.9525H21.3125V26.2041H17.0305V21.2363H21.3125V17.5711C21.3125 13.317 23.9066 11.0029 27.6905 11.0029H31.5229L31.4952 15.6312Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_23894_45360",
    x1: 46.5804,
    y1: 24.9835,
    x2: 2.13306,
    y2: 24.9835,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#078AE8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#122877"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_23894_45360"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48.653,
    height: 48.653,
    fill: "white",
    transform: "translate(0.0300293 0.650879)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacebook);
export default __webpack_public_path__ + "static/media/facebook.d300b529cee43aceffeed88ffff83d63.svg";
export { ForwardRef as ReactComponent };